import React from 'react';
import styled from 'styled-components';
import EditDeliveryZoneForm from './EditDeliveryZoneForm';
import DeliveryZonesEditShape from './DeliveryZoneEditShape';
import { Button } from 'merchant-portal-components';
import {
  ComponentCard,
  HorizontalLine,
  ContainerDiv,
  GridWrapper,
} from '../../common/styledComponents';

const EditDeliveryZoneContainer = styled.div`
  padding: 35px;
`;

let DeliveryZonesEdit = (props) => {
  const {
    deliveryZoneObjects,
    handleDeliveryZoneVisibility,
    editingColour,
    handleSaveChangesButtonClick,
    handleEditDeliveryZoneFormSubmit,
    handleCancelButtonClick,
    locationCoords,
  } = props;

  return (
    <ComponentCard>
      <EditDeliveryZoneForm
        handleEditDeliveryZoneFormSubmit={handleEditDeliveryZoneFormSubmit}
      />
      <HorizontalLine />
      <EditDeliveryZoneContainer>
        <DeliveryZonesEditShape
          deliveryZoneObjects={deliveryZoneObjects}
          handleDeliveryZoneVisibility={handleDeliveryZoneVisibility}
          editingColour={editingColour}
          locationCoords={locationCoords}
        />
      </EditDeliveryZoneContainer>
      <ContainerDiv margin="35px 35px 0 35px">
        <GridWrapper>
          <ContainerDiv>
            <Button secondary onClick={() => handleCancelButtonClick()}>
              Cancel
            </Button>
          </ContainerDiv>
          <ContainerDiv align="right">
            <Button onClick={() => handleSaveChangesButtonClick()}>
              Save Changes
            </Button>
          </ContainerDiv>
        </GridWrapper>
      </ContainerDiv>
    </ComponentCard>
  );
};

export default DeliveryZonesEdit;
